import c from './assets/sass/item.module.scss'

export const MenuItem = ({ icon, label, onClick, rightContent }) => {
    return (
        <div className={c.component} onClick={onClick}>
            <div className={c.icon}>
                <img src={icon} alt="" />
            </div>
            <div className={c.label}>{label}</div>
            {rightContent && <div className={c.right}>{rightContent}</div>}
        </div>
    )
}
